import { render, staticRenderFns } from "./OAuthSuccess.vue?vue&type=template&id=6ff66f4c&"
import script from "./OAuthSuccess.vue?vue&type=script&lang=ts&"
export * from "./OAuthSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports